var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { QuestionAcceptedState } from '../../../learnware/LearnwareEnums';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { runtime } from '../../../runtime/Runtime';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { flatten, uniq } from '../../../../utils/helper/lodash_replacements';
import { APIData } from '../../../api/APIData';
export class TopicMicroQuestions {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    microQuestionsVersion = 0;
    get topic() {
        return this.parent;
    }
    get microQuestionsWithHidden() {
        const updateOnNewVersion = this.microQuestionsVersion;
        return this.microQuestionsQuery.streamedRef;
    }
    get microQuestions() {
        return this.microQuestionsWithHidden.filter(micro => micro.accepted === QuestionAcceptedState.Online);
    }
    microQuestionForId(questionId) {
        return this.microQuestions.find(micro => micro.id === questionId);
    }
    get hiddenMicroQuestions() {
        return this.microQuestionsWithHidden.filter(micro => micro.accepted !== QuestionAcceptedState.Online);
    }
    get microQuestionsQuery() {
        return new APIData({
            route: `/api/topic/${this.topic.id}/microquestions`,
            defaultValue: [],
        });
    }
    get containedQuestionTypeNames() {
        return uniq(this.microQuestions.map(q => q.questionType));
    }
    get containedTopicIds() {
        return uniq(this.microQuestions.map(q => q.topic_id));
    }
    get containedTopics() {
        return uniq(this.containedTopicIds.map(id => runtime.model.stream.topic[id]).filter(topic => !!topic));
    }
    get containedBundles() {
        const actorsHavingBundles = [...this.containedTopics, ...this.topic.locationSteps.allSteps];
        return uniq(flatten(actorsHavingBundles.map(actor => actor.actorBundles.activeBundles)));
    }
    get otherRequiredActors() {
        const other = [];
        other.push(runtime.model.stream.bundle['rJnlnGDBf']); // bundle layoutDraft
        return other.filter(a => !!a);
    }
    get requiredActorsInThisTopic() {
        return uniq([...this.containedTopics, ...this.topic.locationSteps.allSteps, ...this.containedBundles, ...this.otherRequiredActors]);
    }
}
__decorate([
    editable()
], TopicMicroQuestions.prototype, "microQuestionsVersion", void 0);
__decorate([
    computed
], TopicMicroQuestions.prototype, "microQuestionsWithHidden", null);
__decorate([
    memoize
], TopicMicroQuestions.prototype, "microQuestionsQuery", null);
__decorate([
    cachedSet
], TopicMicroQuestions.prototype, "containedQuestionTypeNames", null);
__decorate([
    cachedSet
], TopicMicroQuestions.prototype, "containedTopicIds", null);
__decorate([
    cachedSet
], TopicMicroQuestions.prototype, "containedTopics", null);
__decorate([
    cachedSet
], TopicMicroQuestions.prototype, "containedBundles", null);
__decorate([
    cachedSet
], TopicMicroQuestions.prototype, "otherRequiredActors", null);
